// extracted by mini-css-extract-plugin
module.exports = {"NoMargin":"NoMargin--egnQV","Tabs":"Tabs--3THnj"};